module.exports = __webpack_public_path__ + "static/media/4ODA4.505d21ce.jpg";